import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import Seo from 'components/Seo'
import Nav from 'components/Nav'
import Header from 'components/Header'
import Banner from 'components/Banner'
import ImageCopyBlock from 'components/ImageCopyBlock'
import RelatedBlock from 'components/RelatedBlock'
import ContactBlock from 'components/ContactBlock'
import Footer from 'components/Footer'

const Layout = ({ children, bodyClassName, page }) => {
  const [navIsActive, setNavIsActive] = useState(false)
  const toggleNavIsActive = () => {
    setNavIsActive(!navIsActive)
  }

  const banner = page?.banner?.banner
  const template = page?.template?.templateName
  const imageCopyBlock = page?.imageCopyBlock
  const relatedBlock = page?.relatedBlock
  const contactBlock = page?.contactBlock
  const isEvents = page?.template?.templateName === 'Events'

  return (
    <div
      id='layout'
      className={`body ${bodyClassName} ${navIsActive ? 'nav-is-active' : ''}`}
    >
      <Helmet>
        <meta name='baidu-site-verification' content='code-iB6WZ1AdIw' />
      </Helmet>
      <Seo page={page} />
      <Nav />
      <Header
        navIsActive={navIsActive}
        setNavIsActive={setNavIsActive}
        toggleNavIsActive={toggleNavIsActive}
      />
      <div className='wrap' role='document'>
        <div className='content'>
          <main className='main'>
            {banner && <Banner content={banner} template={template} />}
            {children}
            {imageCopyBlock && <ImageCopyBlock content={imageCopyBlock} />}
            {relatedBlock && (
              <RelatedBlock content={relatedBlock} isEvents={isEvents} />
            )}
            {contactBlock && <ContactBlock content={contactBlock} />}
          </main>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Layout
